export default "__VITE_ASSET__29604d55__"